import React, { useState, useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import shopNowIcon from '../Images/shop.png';

const CollectionSection = () => {
    const [currentCollection, setCurrentCollection] = useState(null);
    const [collections, setCollections] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        axios
          .get('https://backend.printtrio.co.uk/api/category/get-collection')
          .then(response => {
            if (response.data.success) {
              const sortedCollections = response.data.data
                .filter(col => col.is_active === 1) // Optional: if there's an `is_active` field
                .sort((a, b) => a.ordering - b.ordering); // Sort by ordering
      
              setCollections(sortedCollections);
              setCurrentCollection(sortedCollections[0]); // Set the first one as default
            }
          })
          .catch(error => {
            console.error('Error fetching the collections:', error);
          });
      }, []);
      

    const handleShopNowClick = () => {
        if (currentCollection) {
            axios.post('https://backend.printtrio.co.uk/api/product/get-products', { categoryId: currentCollection.id })
                .then(response => {
                    if (response.data.success) {
                        navigate('/collection', { 
                            state: { 
                                scrollToPromo: true, 
                                products: response.data.data,
                                collectionName: currentCollection.name,
                                collectionDescription: currentCollection.description,
                                collectionimage: currentCollection.image,
                                collectionBanner: currentCollection.banner,
                            } 
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching the products:', error);
                });
        }
    };

    const getButtonClass = (collection) => {
        return `font-semibold hover:text-gray-300  ${currentCollection && currentCollection.id === collection.id ? 'text-black' : 'text-gray-500'}`;
    };
    const isMobile = window.innerWidth < 768;

    const renderContent = () => {
        if (!currentCollection) return null;
        return (
            <div 
                className="flex flex-col md:flex-row items-center rounded-xl shadow-lg overflow-hidden backdrop-blur-sm w-full"
                style={{ 
                    backgroundImage: `url(${currentCollection.image})`,
                    backgroundSize: 'contain', 
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    aspectRatio: '16 / 6',
                    
                }}
            >
                <div className="p-2 md:p-12 xl:p-28 md:pr-16 lg:pr-72 flex-1 w-full">
                    <h2 className="text-md md:text-3xl xl:text-5xl text-white font-semibold" style={{ fontFamily: 'arial' }}>{currentCollection.name}</h2>
                    <div className="md:pr-20 lg:pr-80 w-52 md:w-80 lg:w-full max-w-2xl">
                        <p className="mt-1 md:mt-6 text-xs md:text-base text-gray-200" style={{ fontFamily: 'arial' }}>
                            {currentCollection.description}
                        </p>
                    </div>
                    <div className="p-2  flex-1 flex justify-start">

                    <button 
                        className="mt-2 md:mt-8 text-xs md:text-sm inline-flex items-center bg-white px-2 md:px-6 py-2 md:py-3 rounded-full tracking-wide shadow"
                        style={{ fontFamily: 'arial', color: '#191919' }}
                        onClick={handleShopNowClick}
                    >
                        Shop Now
                        <img src={shopNowIcon} alt="Shop Now" style={{ marginLeft: '8px', width: '16px', height: '16px' }} />
                    </button>
                </div>
                </div>
            </div>
        );
    };

    return (
        <div className="flex flex-col bg-white max-w-screen-2xl mx-auto px-0 xl:px-20 relative">
            {collections.length > 0 && (
            <div className="p-6 md:p-12 px-4 md:px-12 xl:px-48 mb-10 w-full">
                <div className="flex flex-col mb-6 md:mb-8">
                
                    <h1 className="text-3xl md:text-5xl font-bold text-center text-black mb-6 md:mb-10" style={{ fontFamily: 'arial' }}>Collection Section</h1>
               
                  <div className="flex flex-row justify-center gap-6">
                        {collections.map(collection => (
                            <button 
                                key={collection.id} 
                                className={getButtonClass(collection)} 
                                onClick={() => setCurrentCollection(collection)}
                            >
                                {collection.name}
                            </button>
                        ))}
                    </div>
                </div>
                {renderContent()}
            </div>
                 )}
        </div>
    );
};

export default CollectionSection;
